import useTypedContext from "hooks/useTypedContext";
import { StackContext } from "views/Stack/Context";
import { AnalyticsPage } from "hooks/useAnalytics";
import useCanLockStack from "shared/Stack/access/useCanLockStack";
import useCanUnlockStack from "shared/Stack/access/useCanUnlockStack";

import LockButton from "../LockButton";
import UnlockButton from "../UnlockButton";

type StackLockOrUnlockButtonProps = {
  analyticsPage?: AnalyticsPage;
};

const StackLockOrUnlockButton = ({ analyticsPage }: StackLockOrUnlockButtonProps) => {
  const { stack } = useTypedContext(StackContext);

  const canLockStack = useCanLockStack()(stack);
  const canUnlockStack = useCanUnlockStack()(stack);

  return (
    <>
      {(canLockStack.result || canLockStack.message) && (
        <LockButton
          stackId={stack.id}
          analyticsPage={analyticsPage}
          disabledTooltip={canLockStack.message}
        />
      )}
      {(canUnlockStack.result || canUnlockStack.message) && (
        <UnlockButton
          stackId={stack.id}
          analyticsPage={analyticsPage}
          disabledTooltip={canUnlockStack.message}
        />
      )}
    </>
  );
};

export default StackLockOrUnlockButton;
